import { Component, Input, forwardRef, SimpleChange } from '@angular/core';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { TripService } from '../../../services/trip.service';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { TripSelectDetail } from '../../../models/trips/tripSelectDetail';

@Component({
	selector: 'ztsi-trip-select',
	templateUrl: './ztsi-trip-select.component.html',
	styleUrls: ['./ztsi-trip-select.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiTripSelectComponent),
			multi: true
		}
	]
})
export class ZtsiTripSelectComponent implements ControlValueAccessor {
	trips: TripSelectDetail[] = [];
    isLoading: boolean = false;
	
	@Input() isDisabled: boolean = false;
	@Input('value') _value: string;
    @Input() clientId: number;
    @Input() applyPaidStyle: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _tripService: TripService
	) { }	

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this.loadSelection();
	}

	loadSelection() {
		this.isLoading = true;
		this._tripService.getTripsDropdownList(this.clientId).subscribe(response => {
			if (response.length != undefined) {
                this.trips = response;
			}
			else {
				console.log('Unable to load trip selection.');
            }
            
            if(this.trips.find(x => x.id.toString() == this.value) == undefined){
                this.value = null;
            }
			this.isLoading = false;
		});
    }
    
    ngOnChanges(changes: { [propertyName: string]: SimpleChange }) {
		if (changes.clientId != undefined) {
            this.clientId = changes.clientId.currentValue;
			this.loadSelection();
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-trip-select/ztsi-trip-select.component.ts